import {StyleSheet} from 'react-native';
import {COLORS, FONTS} from '../../../utils/Constants';

export default StyleSheet.create({
  breadCrumbContainerStyle: {
    flexDirection: 'row',
  },
  rightDotStyle: {
    marginLeft: -12,
  },
});
